import request from '../untils/request';

// 查看概况信息
export function selectHomePageOverview() {
  return request({
    url: '/homePage/selectHomePageOverview',
    method: 'get',
  });
}
// 同比环比下拉列表
export function selectLatestTwelveMonth() {
  return request({
    url: '/homePage/selectLatestTwelveMonth',
    method: 'get',
  });
}
// 同比环比图表数据
export function selectYearlyMonthlyData(data) {
  return request({
    url: '/homePage/selectYearlyMonthlyData',
    method: 'get',
    params: data,
  });
}
// 首页获取能耗曲线
export function selectUsageLineChartData(data) {
  return request({
    url: '/homePage/selectUsageLineChartData',
    method: 'get',
    params: data,
  });
}
// 首页获取最近7天缴费曲线
export function selectLatestSevenDaysPayInfo(data) {
  return request({
    url: '/homePage/selectLatestSevenDaysPayInfo',
    method: 'get',
    params: data,
  });
}
// 获取报警数据
export function selectAlarmData(data) {
  return request({
    url: '/homePage/selectAlarmData',
    method: 'get',
    params: data,
  });
}